import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { Layout } from "../../components/layout";
import {
  MyButton,
  CustomModal,
  Dropdown,
  Input,
  LoadingSpinner,
  ActiveFilters,
  Pagination,
  EmptyTable,
} from "../../components";
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import { MdDateRange } from "react-icons/md";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import { IconButton, Menu, MenuItem, Select } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FaFilter, FaMessage } from "react-icons/fa6";
import { TicketingController } from "../../controllers";
import { Cancel } from "../../../assets";
import routes from "../../../core/routes";
import { FaAngleDown } from "react-icons/fa";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

function CustomInput({
  onFocus,
  value,
  onChange,
  title,
  emptyState,
  error,
}: any) {
  return (
    <Input
      emptyState={emptyState}
      myStyle="w-100"
      hideEndAdornment
      type="number"
      error={error}
      onChange={onChange}
      customFocus={onFocus}
      title={title}
      value={value}
    />
  );
}
class Ticketing extends TicketingController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getTicketsList();
    const filtersString = sessionStorage.getItem("filters");
    if (filtersString) {
      const filters = JSON.parse(filtersString);
      const pageValue = filters.page;
    }
  }
  render() {
    const {
      tecketsList,
      loading,
      from_date,
      to_date,
      count,
      subject,
      sender,
      page,
      receiver,
      leadState,
      dealState,
      dealsList,
      addTicketModal,
      ticketState,
      ticketStatesList,
      openModal,
      rowsCountList,
      ticket_id,
      description,
      assignPersonsList,
      assgin_to_id,
      subtitle,
      seen,

      errorsList,
      statesList,
      
    } = this.state;
    const isSeller = this.props.userData?.is_saller === true;
    // {tecketsList?.length > 0 && (page - 1) * count + 1} - {Math.min(page * count, tecketsList?.length)} از {tecketsList?.length} نمایش

    return (
      <>
        <Layout title="تیکت ها">
          <Helmet>
            <title>تیکت ها | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">تیکت ها</span>
                    </div>
                    <div className="headline-btn-group d-flex">
                      <MyButton
                        myStyle="yellow"
                        icon={<FaFilter className="ms-2" />}
                        title=" فیلتر ها"
                        onClick={() => this.setState({ openModal: !openModal })}
                      />

                      <MyButton
                        myStyle="add"
                        icon={<FaMessage className="ms-2" />}
                        title="افزودن تیکت"
                        onClick={() => this.handleAddTicketModal()}
                      />
                    </div>
                  </div>
                  {/* ---------- Active Filters ---------- */}
                  {this.hasActiveFilter() && (
                    <ActiveFilters filters={this.getActiveFiltersList()} />
                  )}

                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell> شماره تیکت</TableCell>
                          <TableCell>موضوع </TableCell>
                          <TableCell>تاریخ ایجاد</TableCell>
                          <TableCell>فرستنده </TableCell>
                          <TableCell>گیرنده </TableCell>

                          <TableCell>وضعیت </TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!tecketsList?.list?.length && <EmptyTable />}
                        {tecketsList?.list?.map((item: any, index: number) => {
                          return (
                            <>
                              <TableRow
                                // key=""
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {item.id}
                                </TableCell>
                                <TableCell>{item?.subject || "--"}</TableCell>
                                <TableCell>{item?.date}</TableCell>
                                <TableCell>
                                  {item?.applicant_name || "--"}
                                </TableCell>
                                <TableCell>
                                  {item?.assgin_to_name || "--"}
                                </TableCell>

                                <TableCell>
                                  {item?.state_title || "--"}
                                  {item?.un_seen > 0 && (
                                    <span
                                      style={{
                                        backgroundColor: "green",
                                        color: "white",
                                        borderRadius: "50%",
                                        padding: "0.2rem 0.5rem",
                                        fontSize: "0.75rem",
                                        marginRight: "0.5rem",
                                        display: "inline-block",
                                        minWidth: "24px",
                                        textAlign: "center",
                                      }}
                                      title="پیام جدید"
                                    >
                                      {item.un_seen}
                                    </span>
                                  )}
                                </TableCell>
                                 <TableCell>
                                   <MyButton
                                    link={this.showTicketDetails(item)}
                                    myStyle="bg-blue table-btn"
                                    title="نمایش  "
                                  />

                                  {/* <PopupState variant="popover" popupId="demo-popup-menu">
                                    {(popupState: any) => (
                                      <>
                                        <IconButton
                                          sx={{
                                            color: "#0c1a58",
                                            padding: "4px"
                                          }}
                                          {...bindTrigger(popupState)}
                                        >
                                          <BsThreeDotsVertical />
                                        </IconButton>
                                        <Menu {...bindMenu(popupState)}>
                                          <MenuItem> <Link to={this.showTicketDetails(item)}> جزئیات </Link></MenuItem>
                                        </Menu>
                                      </>
                                    )}
                                  </PopupState> */}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={tecketsList?.pages ? tecketsList?.pages : 1}
                      page={page}
                      total={tecketsList?.total}
                      pageNumber={tecketsList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
                <CustomModal
                  myStyle="users-list-filter-modal custom-modal-overflow-hidden"
                  openModal={this.state.openModal}
                  onClose={() => this.closeModal()}
                  size="lg"
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">
                        بر اساس اطلاعات تیکت
                      </h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() => this.closeModal()}
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row cols-2">
                      <Input
                        myStyle=" w-100"
                        title="عنوان تیکت "
                        value={subject}
                        onChange={(e: any) =>
                          this.handleSubjectChange(e.target.value)
                        }
                        emptyState={() => this.setState({ subject: "" })}
                      />
                      {/* <Input type="number" myStyle="" title="تعداد  " value={count} onChange={(e: any) => this.handleCountChange(e.target.value)} emptyState={() => this.setState({ count: "" })} /> */}
                      <Input
                        myStyle=" w-100"
                        title="شماره تیکت "
                        value={ticket_id}
                        onChange={(e: any) =>
                          this.handleChangeTicketId(e.target.value)
                        }
                        emptyState={() => this.setState({ ticket_id: "" })}
                      />
                    </div>
                    

                    <div className="custom-modal-row cols-2">
                      <DatePicker
                        ref={this.datePickerRef}
                        render={
                          <CustomInput
                            title="از تاریخ"
                            emptyState={() => this.emptyFromDate()}
                          />
                        }
                        value={from_date}
                        dateSeparator=" تا "
                        calendar={persian}
                        locale={persian_fa}
                        placeholder=" از تاریخ "
                        containerClassName="custom-modal-item-w-50 filter-date-container"
                        inputClass="custom-date-input"
                        calendarPosition="bottom-right"
                        onChange={this.handleChangeFromDate}
                      />
                      <DatePicker
                        ref={this.datePickerRef}
                        render={
                          <CustomInput
                            title="تا تاریخ"
                            emptyState={() => this.emptyToDate()}
                          />
                        }
                        dateSeparator=" تا "
                        calendar={persian}
                        locale={persian_fa}
                        value={to_date}
                        placeholder="تا تاریخ"
                        containerClassName="custom-modal-item-w-50 filter-date-container"
                        inputClass="custom-date-input"
                        onChange={this.handleChangeToDate}
                      />
                    </div>
                    <div className="custom-modal-row cols-2">
                      <Input
                        myStyle="custom-modal-item-w-50 "
                        title=" گیرنده "
                        value={receiver}
                        onChange={(e: any) =>
                          this.handleReceiver(e.target.value)
                        }
                        emptyState={() => this.setState({ receiver: "" })}
                      />
                      <Input
                        myStyle="custom-modal-item-w-50 "
                        title="  فرستنده"
                        value={sender}
                        onChange={(e: any) => this.handleSender(e.target.value)}
                        emptyState={() => this.setState({ sender: "" })}
                      />
                    </div>
                    {isSeller && (
                    <div className="custom-modal-row cols-2">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={statesList}
                        objectList
                        myStyle="custom-modal-item-w-50"
                        title="وضعیت سرنخ"
                        value={leadState}
                        onChange={(e: any) => {
                          this.handleChange(e);
                        }}
                        emptyState={() => this.emptyState()}
                      >
                        {statesList &&
                          statesList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.name} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={dealsList}
                        objectList
                        myStyle="custom-modal-item-w-50"
                        title="وضعیت معامله"
                        value={dealState}
                        onChange={(e: any) => {
                          this.handleChangeDealState(e);
                        }}
                        emptyState={() => this.emptyDealState()}
                      >
                        {dealsList &&
                          dealsList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.name} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                    </div>
                    )}
                    {isSeller && (
                    <div className="custom-modal-row cols-2">
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        items={ticketStatesList}
                        objectList
                        myStyle="custom-modal-item-w-50"
                        title="وضعیت تیکت"
                        value={ticketState}
                        onChange={(e: any) => {
                          this.handleChangeTicketState(e);
                        }}
                        emptyState={() => this.emptyTicketState()}
                      >
                        {ticketStatesList &&
                          ticketStatesList?.map((item: any, index: number) => {
                            return (
                              <MenuItem value={item?.name} key={index}>
                                {item?.title}
                              </MenuItem>
                            );
                          })}
                      </Dropdown>
                      <Dropdown
                        placeholder="یک گزینه را انتخاب کنید"
                        myStyle="custom-modal-item-w-50"
                        title="دیده شده"
                        value={seen}
                        onChange={(e: any) => {
                          this.handleSeenChange(e);
                        }}
                        emptyState={() => this.emptySeen()}
                      >
                        <MenuItem value="true">بله</MenuItem>
                        <MenuItem value="false">خیر</MenuItem>
                      </Dropdown>
                    </div>
                    )}
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={this.state.isFilterApplying}
                        onClick={this.handleApplyFilter}
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="users-list-filter-modal"
                  openModal={addTicketModal}
                  size="lg"
                  onClose={() =>
                    this.setState({
                      addTicketModal: !addTicketModal,
                      errorsList: [],
                      subtitle: "",
                      assgin_to_id: "",
                      description: "",
                    })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">افزودن تیکت</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        width="20"
                        height="20"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            addTicketModal: !addTicketModal,
                            errorsList: [],
                            loading: false,
                            subtitle: "",
                            description: "",
                            assgin_to_id: "",
                          })
                        }
                      />
                    </div>
                    <div className="custom-modal-content">
                    <div className="custom-modal-body">
                      <div className="custom-modal-row cols-2">
                        <Input
                          error={
                            errorsList.filter(
                              (name: { path: string }) =>
                                name.path === "subtitle"
                            )?.[0]?.errors?.[0]
                          }
                          title="موضوع تیکت"
                          myStyle=""
                          value={subtitle}
                          onChange={(e: any) => {
                            this.setState({ subtitle: e.target.value });
                          }}
                        />
                        <Dropdown
                          title=" شخص مورد نظر"
                          items={assignPersonsList}
                          error={
                            errorsList.filter(
                              (name: { path: string }) =>
                                name.path === "assgin_to_id"
                            )?.[0]?.errors?.[0]
                          }
                          myStyle=""
                          value={assgin_to_id}
                          onChange={(e: any) => {
                            this.setState({ assgin_to_id: e.target.value });
                          }}
                        >
                          {assignPersonsList &&
                            assignPersonsList?.map(
                              (item: any, index: number) => {
                                return (
                                  <MenuItem value={item?.id} key={index}>
                                    {item?.title}
                                  </MenuItem>
                                );
                              }
                            )}
                        </Dropdown>
                      </div>
                      
                      <div className="custom-modal-row">
                        <Input
                          rows={3}
                          multiline
                          myStyle="custom-modal-item w-100"
                          title="توضیحات تیکت"
                          error={
                            errorsList.filter(
                              (name: { path: string }) =>
                                name.path === "description"
                            )?.[0]?.errors?.[0]
                          }
                          value={description}
                          onChange={(e: any) => {
                            this.setState({ description: e.target.value });
                          }}
                        />
                      </div>
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="تایید و ثبت"
                        loading={this.state.isUploadingTicket}
                        onClick={() => this.uploadTicket()}
                      />
                    </div>
                    </div>
                  </>
                </CustomModal>


                  
              </>
            )}
          </div>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};

export default connect(mapStateToProps)(Ticketing);
